import * as React from 'react'
import Container from '@mui/material/Box'
import Header from 'Components/Header/Header'
import BottomNavigation from 'Components/BottomNavigation'
import FileUpload from 'Components/FileUpload'

interface Props {
      children: React.ReactNode
}
const Layout: React.FC<Props> = (props) => {
      return (
            <>
                  <Header />
                  <Container>{props.children}</Container>
            </>
      )
}
export default Layout
